// src/components/StoneAggregatePage.js

import React, { useState } from "react";
import "./StoneAggregatePage.css";

import banner from "../images/overallproductimage.png";
import stone from "../images/stone_aggregate_image.png";

function StoneAggregatePage() {
  const [tab, setTab] = useState("description");

  return (
    <>
      {/* ================= Banner ================= */}

      <section
        className="relative h-[320px] md:h-[420px] bg-cover bg-center"
        style={{ backgroundImage: `url(${banner})` }}
      >
        <div className="absolute inset-0 bg-black/40"></div>

        <div className="relative max-w-7xl h-full mx-auto flex items-center px-6 lg:px-8">

          <div>

            <h1 className="text-white text-4xl md:text-6xl font-bold uppercase tracking-wide">
              STONE AGGREGATE
            </h1>

            <div className="w-24 h-1 bg-red-600 mt-5 rounded-full"></div>

          </div>

        </div>

      </section>

      {/* ================= Breadcrumb ================= */}

      <div className="bg-gray-100 border-b">

        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-4">

          <p className="text-gray-600">

            Home

            <span className="mx-2 text-red-600">›</span>

            <span className="font-semibold">
              STONE AGGREGATE
            </span>

          </p>

        </div>

      </div>

      {/* ================= Product ================= */}

      <section className="max-w-7xl mx-auto px-6 lg:px-8 py-16">

        <div className="bg-white rounded-2xl shadow-xl overflow-hidden">

          <div className="grid lg:grid-cols-2 gap-12 items-center p-8 lg:p-14">

            {/* Image */}

            <div className="flex justify-center">

              <div className="product-image">

                <img
                  src={stone}
                  alt="Stone Aggregate"
                  className="w-full max-w-md"
                />

              </div>

            </div>

            {/* Content */}

            <div>

              <span className="inline-block bg-red-100 text-red-600 px-4 py-2 rounded-full text-sm font-semibold mb-5">
                Premium Construction Material
              </span>

              <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 leading-tight">

                STONE AGGREGATE

                <br />

                Manufacturers & Suppliers,

                <span className="text-red-600">
                  {" "}Delhi NCR
                </span>

              </h2>

              <p className="mt-6 text-gray-600 leading-8">

                Stone Aggregate is a high-quality construction material
                widely used in residential, commercial and infrastructure
                projects. It provides excellent strength, durability and
                stability for concrete, road construction, drainage and
                foundation applications.

              </p>

              <div className="mt-8 overflow-hidden rounded-xl border">

                <table className="w-full">

                  <tbody>

                    <tr className="border-b">

                      <td className="bg-gray-50 font-semibold p-4 w-52">
                        Pricing
                      </td>

                      <td className="p-4">
                        ₹850 – ₹950 / Ton
                      </td>

                    </tr>

                    <tr>

                      <td className="bg-gray-50 font-semibold p-4">
                        Stock
                      </td>

                      <td className="p-4">

                        <span className="bg-green-100 text-green-700 px-4 py-2 rounded-full text-sm font-semibold">
                          AVAILABLE
                        </span>

                      </td>

                    </tr>

                  </tbody>

                </table>

              </div>

            </div>

          </div>

        </div>

      </section>

      {/* ================= Tabs ================= */}

      <section className="max-w-7xl mx-auto px-6 lg:px-8">

        <div className="flex flex-wrap border-b">

          <button
            onClick={() => setTab("description")}
            className={`tab-btn ${
              tab === "description" ? "active-tab" : ""
            }`}
          >
            Description
          </button>

          <button
            onClick={() => setTab("specification")}
            className={`tab-btn ${
              tab === "specification" ? "active-tab" : ""
            }`}
          >
            Specification
          </button>

          <button
            onClick={() => setTab("video")}
            className={`tab-btn ${
              tab === "video" ? "active-tab" : ""
            }`}
          >
            Video
          </button>

        </div>

        <div className="bg-white shadow-lg rounded-b-2xl p-8 lg:p-10">
                    {tab === "description" && (

            <div className="space-y-8 animate-fade">

              <div>

                <h2 className="text-3xl font-bold text-gray-900">
                  Stone Aggregate at Affordable Prices
                </h2>

                <div className="w-24 h-1 bg-red-600 mt-4 rounded-full"></div>

              </div>

              <p className="text-gray-600 leading-8">

                Stone Aggregate is one of the most important materials used
                in modern construction. It is extensively used in concrete,
                road construction, bridges, drainage systems and building
                foundations because of its superior strength, durability
                and long service life.

              </p>

              <p className="text-gray-600 leading-8">

                Our premium quality Stone Aggregate is carefully processed
                and graded to provide excellent load-bearing capacity,
                better bonding with cement and consistent performance in
                residential, commercial and industrial construction
                projects.

              </p>

              <div>

                <h3 className="text-2xl font-semibold mb-6">
                  Advantages of Stone Aggregate
                </h3>

                <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">

                  <div className="feature-card">

                    <div className="feature-icon">✓</div>

                    <h4>High Strength</h4>

                    <p>
                      Provides excellent compressive strength for
                      concrete and structural applications.
                    </p>

                  </div>

                  <div className="feature-card">

                    <div className="feature-icon">✓</div>

                    <h4>Durable Material</h4>

                    <p>
                      Long-lasting material with excellent resistance
                      to wear and weather conditions.
                    </p>

                  </div>

                  <div className="feature-card">

                    <div className="feature-icon">✓</div>

                    <h4>Excellent Bonding</h4>

                    <p>
                      Improves the bonding strength of concrete and
                      enhances structural stability.
                    </p>

                  </div>

                  <div className="feature-card">

                    <div className="feature-icon">✓</div>

                    <h4>Multiple Sizes</h4>

                    <p>
                      Available in different sizes suitable for
                      foundations, roads and RCC works.
                    </p>

                  </div>

                  <div className="feature-card">

                    <div className="feature-icon">✓</div>

                    <h4>Low Water Absorption</h4>

                    <p>
                      Helps maintain concrete quality with minimal
                      moisture absorption.
                    </p>

                  </div>

                  <div className="feature-card">

                    <div className="feature-icon">✓</div>

                    <h4>Wide Applications</h4>

                    <p>
                      Ideal for buildings, highways, bridges,
                      landscaping and infrastructure projects.
                    </p>

                  </div>

                </div>

              </div>

            </div>

          )}

          {/* ================= Specification ================= */}

          {tab === "specification" && (

            <div className="animate-fade">

              <h2 className="text-3xl font-bold mb-8">
                Technical Specification
              </h2>

              <div className="overflow-x-auto">

                <table className="spec-table w-full">

                  <tbody>

                    <tr>
                      <td>Available Sizes</td>
                      <td>10 mm, 20 mm & 40 mm</td>
                    </tr>

                    <tr>
                      <td>Material</td>
                      <td>Natural Crushed Stone</td>
                    </tr>

                    <tr>
                      <td>Density</td>
                      <td>Approximately 750 kg/m³</td>
                    </tr>

                    <tr>
                      <td>Strength</td>
                      <td>Grade A</td>
                    </tr>

                    <tr>
                      <td>Water Absorption</td>
                      <td>Less than 0.5%</td>
                    </tr>

                    <tr>
                      <td>Applications</td>
                      <td>
                        RCC, Roads, Foundations, Drainage,
                        Bridges & Construction Works
                      </td>
                    </tr>

                  </tbody>

                </table>

              </div>

            </div>

          )}
                    {/* ================= Video ================= */}

          {tab === "video" && (

            <div className="animate-fade">

              <h2 className="text-3xl font-bold text-center mb-8">
                Product Video
              </h2>

              <div className="max-w-5xl mx-auto">

                <div className="aspect-video rounded-2xl overflow-hidden shadow-xl">

                  <iframe
                    className="w-full h-full"
                    src="https://www.youtube.com/embed/j5iR7VP742U"
                    title="Stone Aggregate"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>

                </div>

              </div>

            </div>

          )}

        </div>

      </section>

      

    </>
  );

}

export default StoneAggregatePage;